import React from "react";

import { Box, ThemeProvider } from "@mui/material";

import { mergeMainTheme } from "@aclymatepackages/themes";

import Header from "./Header";
import Footer from "./Footer";
import ReportPagePaper from "./ReportPagePaper";

import { useDynamicWrappingPages } from "../../../helpers/components/report";

const ReportPageLayout = ({
  showHeader = true,
  startDate,
  endDate,
  content,
  blocks,
  setRefElement,
  pdfLoading,
  pageNumber,
  totalPages,
}) => {
  return (
    <ThemeProvider theme={mergeMainTheme()}>
      <ReportPagePaper pdfLoading={pdfLoading}>
        {showHeader && <Header startDate={startDate} endDate={endDate} />}
        <Box
          id="content-box"
          flexGrow={1}
          px={6}
          py={3}
          sx={{ boxSizing: "border-box" }}
        >
          {content}
          {blocks && (
            <>
              {blocks.map((block, idx) => (
                <div
                  ref={(element) =>
                    setRefElement && setRefElement(element, idx)
                  }
                  item
                  key={`content-block-${idx}`}
                >
                  {block}
                </div>
              ))}
            </>
          )}
        </Box>
        <Footer pageNumber={pageNumber} totalPages={totalPages} />
      </ReportPagePaper>
    </ThemeProvider>
  );
};

const ReportPage = ({ pdfLoading, content, blocks = [], ...otherProps }) => {
  const { pageBlocks, setRefElement } = useDynamicWrappingPages(blocks);

  if (!blocks || pageBlocks.length <= 1) {
    return (
      <ReportPageLayout
        pdfLoading={pdfLoading}
        content={content}
        blocks={blocks}
        setRefElement={setRefElement}
        {...otherProps}
      />
    );
  }

  return (
    <>
      {pageBlocks.map((blocks, idx) => (
        <ReportPageLayout
          pdfLoading={pdfLoading}
          blocks={blocks}
          {...otherProps}
          key={`block-page-${idx}`}
        />
      ))}
    </>
  );
};

export default ReportPage;
